const topbar = {
    docs: 'Documentos',
    help: 'Ajuda',
    /** UNTRANSLATED */
    subscription: 'Subscription',
};
export default Object.freeze(topbar);
